class CustomPointNav extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.isAppear = false;
    this.actionList = [];
    this.domList = [];

    this.onScrollHandler = this.onScroll.bind(this);

    this.interObsever = new IntersectionObserver(this.initObserverCallback.bind(this));
    this.querySelectorAll('.nav-list-item').forEach(item => {
      item.addEventListener('click', this.onClickHandler)
      if (item && item.dataset && item.dataset.linkId) {
        // const dom = document.getElementById(item.dataset.linkId)
        // if (dom) {
        //   this.domList.push(dom)
        //   // this.interObsever.observe(dom)
        // }
        const ids = document.querySelectorAll(`*[id="${item.dataset.linkId}"]`);
        if (ids.length){
          ids.forEach(item=>{
            let computedStyle = window.getComputedStyle(item);
            if (computedStyle.display==='block'){
              this.domList.push(item)
            }
          })
        }

      }
    })

    if (this.domList.length > 0) {
      window.addEventListener('scroll', this.onScrollHandler, false);
    }
  }

  onScroll(event) {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const showList = []
    this.domList.forEach(dom => {
      const rect = dom.getBoundingClientRect()
      const index = showList.findIndex(item => item.id === dom.id)
      if (rect.top <= 0) {
        if (index < 0) {
          showList.push({
            id: dom.id,
            top: rect.top
          })
        } else {
          showList[index].top = rect.top
        }
      } else if (rect.top > 0 && index > 0) {
        showList.splice(index, 1)
      }
    })

    this.querySelectorAll(`[data-link-id]`).forEach(dom => {
      dom.classList.remove('action')
    })
    if (showList.length > 0) {
      this.querySelector(`[data-link-id]`).classList.remove('action')
      const max = Math.max.apply(null, showList.map(item => item.top))
      showList.forEach(item => {
        const id = item.id
        if (item.top === max) {
          this.querySelector(`[data-link-id='${id}']`).classList.add('action')
        }
      })
      this.open()
    } else {
      this.hide()
    }
    this.currentScrollTop = scrollTop;
  }



  onClickHandler() {
    // const dom = document.getElementById(this.dataset.linkId)
    // console.log('dom',dom)
    // if (!dom) {
    //   return
    // }
    // const top = dom.getBoundingClientRect().top + document.documentElement.scrollTop + 1
    // window.scrollTo({ top, behavior: 'smooth' });

    const ids = document.querySelectorAll(`*[id="${this.dataset.linkId}"]`);
    // console.log("ids: ",ids)
    if (ids.length){
      ids.forEach(item=>{
        let computedStyle = window.getComputedStyle(item);
        if (computedStyle.display==='block'){
          console.log('computedStyle: ',computedStyle);
          const top = item.getBoundingClientRect().top + document.documentElement.scrollTop + 1
          window.scrollTo({ top, behavior: 'smooth' });
        }
      })
    }

  }

  initObserverCallback(e) {
    e.forEach((obj) => {
      if (obj.isIntersecting) {
        this.querySelector(`[data-link-id='${obj.target.id}']`).classList.add('action')
        if (!this.actionList.includes(obj.target.id)) {
          this.actionList.push(obj.target.id)
        }
        this.open()
      } else {
        this.querySelector(`[data-link-id='${obj.target.id}']`).classList.remove('action')
         const index = this.actionList.indexOf(obj.target.id)
        if (index >= 0) {
          this.actionList.splice(index, 1)
        }
        if (this.actionList.length === 0) {
          this.hide()
        }
      }
    })
  }

  disconnectedCallback() {
    if (this.domList.length > 0) {
      window.removeEventListener('scroll', this.onScrollHandler, false);
    }
    this.querySelectorAll('.nav-list-item').forEach(item => {
      item.removeEventListener('click', this.onClickHandler)
    })
    if (this.interObsever) {

    }
  }

  open() {
    this.isAppear = true;
    this.classList.add('show');
    $(this).removeClass('hidden')
  }

  hide() {
    this.isAppear = false;
    this.classList.remove('show');
    $(this).addClass('hidden')
  }
}
customElements.define('custom-ponit-nav', CustomPointNav);
